import { copy_standard_attributes } from "../../../helpers/copy_standard_attributes";
import { Snippet } from "./Snippet";
export var NBTType;
(function (NBTType) {
    NBTType[NBTType["storage"] = 0] = "storage";
    NBTType[NBTType["entity"] = 1] = "entity";
    NBTType[NBTType["block"] = 2] = "block";
})(NBTType || (NBTType = {}));
export class NBTSnippet extends Snippet {
    constructor(id = null) {
        super(id);
        this.type = NBTType.entity;
        this.nbt = "";
        // This has to remain storage for legacy reasons, but
        // it's actually going to be compiled to whichever field
        // type specifies
        this.storage = "";
        this.interpret = false;
    }
    copy() {
        let newValue = new NBTSnippet(this.id);
        newValue.nbt = this.nbt;
        newValue.storage = this.storage;
        newValue.type = this.type;
        newValue.interpret = this.interpret;
        copy_standard_attributes(this, newValue);
        return newValue;
    }
}
